<template>
<div>
    <md-list-item v-for="(unitPlan, idx) in unitPlans" :key="idx">
        <router-link :to="{name: 'unit-plan', params: {id:unitPlan.id}}">{{ unitPlan.name }} ({{formatDate(unitPlan.start_date)}})</router-link>
    </md-list-item>  
</div>
</template>

<script>
// @ is an alias to /src
import { db } from '../main'
// import firebase from 'firebase/app'
import moment from 'moment'
export default {
  name: 'UnitPlanNavigation',
  data() {
    return {
      unitPlans: []
    }
  },
  firestore() {
    return {
      unitPlans: db.collection('unitPlans').where('uid', '==', this.$store.getters.user.uid)
    }
  },
  methods: {
    formatDate: function(timestamp)
    {
      if(timestamp)
        return moment(timestamp.toDate()).format("YYYY-MM-DD")
      else
        return "--"
    } 
  }
}
</script>
<style lang="css" scoped>
  .md-card {
    max-width: 600px;
    margin: 4px;
    display: block;
    vertical-align: top;
  }
</style>


// WEBPACK FOOTER //
// src/components/UnitPlanNavigation.vue